module.exports = __webpack_public_path__ + "static/media/banner_resourcesforyou-Primary_School-Riskanddanger.1bb24e23.png";